import { Component, Input, ViewChild, computed, effect, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { AppstateService } from 'src/app/services/appstate.service';
import { DataService } from 'src/app/services/data.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { IRisikenChancen } from 'src/app/types/IRisikenchancen';

// DataGrid for DevExtreme - Editing with dataRowTemplate
// https://supportcenter.devexpress.com/ticket/details/t1177465/datagrid-for-devextreme-editing-with-datarowtemplate

@Component({
  selector: 'app-budget-risiken-chancen',
  // standalone: true,
  // imports: [],
  templateUrl: './budget-risiken-chancen.component.html',
  styleUrl: './budget-risiken-chancen.component.css'
})
export class BudgetRisikenChancenComponent {
  
  @Input()
  set projektid(id: number) {
    if (id) {
      this.appStateService.projektId.set(id);
      this.appStateService.projektInfoId.set(id);
    }
  }
  @Input()
  set baid(id: number) {
    this.appStateService.budgetantragId.set(id);
  }

  @ViewChild(DxDataGridComponent, { static: false })
  public dataGrid!: DxDataGridComponent;
  public projektId?: number;
  public antragId?: number;
  public dataRisikenChancen = computed<IRisikenChancen[] | null>(() => this.dataService.budgetantragRisikenChancen());
  public infoText = signal('');
  public dataCountText = signal('');
  public showFilterRow = signal(false);
  public showHeaderFilter = signal(false);
  public closeButtonOptions: any = {
    text: "Beenden",
    stylingMode: "text",
    onClick: (e: any) => {
    	this.dataGrid.instance.cancelEditData();
    }
  }

  constructor(private activeRoute: ActivatedRoute,
              private appStateService: AppstateService,
              public navigationService: NavigationService,            
              private dataService: DataService){

    effect(() => {
      if (this.dataRisikenChancen == null) {
        this.dataGrid.instance.beginCustomLoading("Risken und Chancen werden geladen...");
      } else {
        this.dataGrid.instance.endCustomLoading();
      }
    });       
  }

  BackButtonClick() {
    this.navigationService.navigateBackToBudgetantragDashboard(this.activeRoute);
  }

  ContentReady(e: any) {
    if (e.component.getCombinedFilter() != null) {
      this.infoText.set('Tabellenfilterung aktiv');
    } else {
      this.infoText.set('');
    }
    this.dataCountText.set(e.component.totalCount() + ' Datensätze');
  }

  RisikenDataGridRowDblClick(e: any) {
    if (e.rowType === "data") {
      this.dataGrid.instance.editRow(e.dataIndex);
    }
  }

}
